module.exports = __webpack_public_path__ + "static/media/checkbox_checked_desktop.47fe980a.svg";